

import { Button } from "@/components/ui/button";
import { useI18n } from "@/i18n";
import { Globe } from "lucide-react";

const LanguageSwitcher = () => {
  const { language, toggleLanguage } = useI18n();

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleLanguage}
      className="fixed top-4 right-4 z-50"
    >
      <Globe className="mr-2 h-4 w-4" />
      {language === 'en' ? '中文' : 'English'}
    </Button>
  );
};

export default LanguageSwitcher;
